import styled from 'styled-components';

import { Color, FontWeight, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Logo } from '../logo/logo.component';
import { MenuPosition } from '../menuPosition/menuPosition.component';

import { ChildPositionProps, ChildrenPositionsProps, MainMenuPositionProps } from './slideMenu.types';

export const InnerContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const StyledLogo: StyledComponent<typeof Logo> = styled(Logo)`
  position: absolute;
  top: 32px;
  left: 32px;
  max-width: none;
`;

export const MenuPositions: StyledComponent<'div'> = styled.div`
  position: absolute;
  left: 0;
  top: 120px;
  padding-bottom: 80px;
  white-space: nowrap;
`;

export const MenuPositionGroup: StyledComponent<'div'> = styled.div`
  & + & {
    margin-top: 12px;
  }
`;

export const MainMenuPosition: StyledComponent<typeof MenuPosition, MainMenuPositionProps> = styled(MenuPosition)<MainMenuPositionProps>`
  display: flex;
  align-items: center;
  border-left: 2px solid ${({ $active }: MainMenuPositionProps): Color => $active ? Color.Error500 : Color.Transparent};
  color: ${({ $active }: MainMenuPositionProps): Color => $active ? Color.Error500 : Color.Black};
  padding-left: 32px;
  white-space: nowrap;
`;

export const MainMenuPositionLabel: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 14px;
  line-height: 18px;
  margin-left: 30px;
  transition: 0.3s;
  padding: 6px 0;
`;

export const ChildrenPositions: StyledComponent<'div', ChildrenPositionsProps> = styled.div<ChildrenPositionsProps>`
  padding-left: 66px;
  overflow: hidden;
  max-height: 0;
  transition: 0.3s;

  ${({ $isVisible }: ChildrenPositionsProps) => $isVisible && `
    max-height: 300px;
    margin: 20px 0 35px;
  `};
`;

export const ChildPosition: StyledComponent<typeof MenuPosition, ChildPositionProps> = styled(MenuPosition)<ChildPositionProps>`
  font-weight: ${FontWeight.Medium};
  font-size: 14px;
  line-height: 18px;
  color: ${({ $active }: ChildPositionProps): Color => $active ? Color.Black : Color.Gray400};
  white-space: nowrap;

  & + & {
    margin-top: 12px;
  }
`;

export const Container: StyledComponent<'div'> = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  border-right: 1px solid ${Color.Gray300};
  width: 88px;
  overflow: hidden;
  overflow-y: auto;
  transition: 0.3s;
  background-color: ${Color.White};
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  z-index: ${ZIndex.SlideMenu};

  &::-webkit-scrollbar {
    width: 0;
  }

  &:hover {
    width: 240px;

    ${MainMenuPositionLabel} {
      margin-left: 12px;
    }
  }
`;
